import { FormikHelpers } from 'formik'

import {
  replaceObjectKeys,
  setFieldErrors,
} from '../../../../../lib/helpers/helperFunctions'
import constraintViolationService from '../../../../../lib/services/constraintViolationService'
import { ConstraintViolationListError } from '../../../../../types/api'
import { ClientEntity } from '../../../../../types/entities'
import { AboutYourClientInput } from '../../types'
import { AboutYourClientInputFields } from './constants'

export function getInitialValues(options?: {
  previousData?: AboutYourClientInput
  isEditMode: boolean
}): AboutYourClientInput {
  const previousData = options?.previousData
  const isEditMode = options?.isEditMode ?? true
  const userFirstName = previousData?.user_name_first || ''
  const userLastName = previousData?.user_name_last || ''

  function getUserFullName() {
    if (previousData?.user_name) {
      return previousData.user_name
    }

    return userFirstName || userLastName
      ? `${userFirstName} ${userLastName}`
      : ''
  }

  function getInitialDataSharingValue() {
    // If the user previously answered the question, use their answer
    if (typeof previousData?.consents_to_data_sharing === 'boolean') {
      return previousData.consents_to_data_sharing
    }

    // Otherwise, default it to true if we're in the edit mode
    return isEditMode ? true : undefined
  }

  return {
    existing_client: previousData?.existing_client,
    user_name: getUserFullName(),
    user_name_first: userFirstName,
    user_name_last: userLastName,
    user_date_of_birth: previousData?.user_date_of_birth,
    user_email: previousData?.user_email || '',
    user_telephone: previousData?.user_telephone || '',
    user_private_situation: previousData?.user_private_situation,
    user_professional_situation:
      previousData?.user_professional_situation || [],
    consents_to_data_sharing: getInitialDataSharingValue(),
  }
}

export function handleCreateOrUpdateClientError(
  errors: ConstraintViolationListError,
  formikHelpers: FormikHelpers<AboutYourClientInput>,
) {
  const formattedErrors = constraintViolationService.formatErrors(errors)

  // Map the field names for the Client entity to the field names we
  // use in the form.
  const keyReplacements: Partial<
    Record<keyof ClientEntity, keyof AboutYourClientInput>
  > = {
    email: AboutYourClientInputFields.user_email,
    firstName: AboutYourClientInputFields.user_name_first,
    lastName: AboutYourClientInputFields.user_name_last,
    dateOfBirth: AboutYourClientInputFields.user_date_of_birth,
    telephone: AboutYourClientInputFields.user_telephone,
  }

  const fieldErrors = replaceObjectKeys(formattedErrors, keyReplacements)

  setFieldErrors(fieldErrors, formikHelpers)
}
